import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { ISurveyCampaign } from '../core.interface';
import { IconFieldModule } from 'primeng/iconfield';
import { Tooltip } from 'primeng/tooltip';
import { InputIconModule } from 'primeng/inputicon';
import { TooltipModule } from 'primeng/tooltip';
import { LucideAngularModule } from 'lucide-angular';
import { ButtonModule } from 'primeng/button';
@Component({
  selector: 'app-survey-bottom-sheet',
  standalone: true,
  imports: [CommonModule, FormsModule, LucideAngularModule, ButtonModule],
  templateUrl: './survey-bottom-sheet.component.html',
  styleUrls: ['./survey-bottom-sheet.component.scss'],
})
export class SurveyBottomSheetComponent {
  @Input() survey!: ISurveyCampaign;
  @Input() tenantId: any;

  @Output() submitSurvey = new EventEmitter<any>();
  @Output() closeModal = new EventEmitter<any>();
  selectedScore: number | null = null;
  feedback = '';

  readonly maxChars = 500;

  constructor() {}

  get isLowScore(): boolean {
    return this.selectedScore !== null && this.selectedScore <= 2;
  }

  get canSubmit(): boolean {
    if (this.selectedScore === null) return false;

    if (this.isLowScore) {
      return this.feedback.trim().length > 0;
    }

    return true;
  }

  close(): void {
    this.closeModal.emit();
  }

  selectScore(score: number): void {
    this.selectedScore = score;

    if (!this.isLowScore) {
      this.feedback = '';
    }
  }

  async onSubmit(): Promise<void> {
    if (!this.canSubmit) return;

    const payload = {
      status: 'answered',
      score: this.selectedScore,
      feedback: this.isLowScore ? this.feedback.trim() : null,
    };

    this.submitSurvey.emit(payload);

    await this.closeModal.emit(payload);
  }

  async skipSurvey(): Promise<void> {
    const payload = {
      tenantId: this.tenantId,
      status: 0,
      score: 0,
      comments: '',
      fromApp: 0,
    };

    await this.closeModal.emit(payload);
  }
}
